<template>
  <div class="w-full">
    <PageHeader class="my-20" title="Weinwissen" subtitle="Die Geschmacksabstufungen beim Wein nach Restzuckergehalt" />
    <div class="mb-20">
      <p class="text-base text-2xl font-bold">
        Trocken; sec, secco; asciutto, dry:
      </p>
      <ul class="ml-6 my-5 text-base text-2xl list-disc">
        <li>4 g je Liter oder</li>
        <li>
          9 g je Liter, sofern der in g je Liter Weinsäure ausgedrückte Gesamtsäuregehalt um 2 g je Liter niedriger ist
          als der Restzuckergehalt
        </li>
      </ul>
      <p class="text-base text-2xl font-bold">
        Halbtrocken; demi sec, abbocato; medium dry:
      </p>
      <ul class="ml-6 my-5 text-base text-2xl list-disc">
        <li>12 g je Liter oder</li>
        <li>
          18 g je Liter, sofern der in g je Liter ausgedrückte Gesamtsäuregehalt höchstens um 10 g je Liter niedriger
          ist als der Restzuckergehalt
        </li>
      </ul>
      <p class="text-base text-2xl font-bold">
        Lieblich; moelleux, amabile, medium sweet:
      </p>
      <ul class="ml-6 my-5 text-base text-2xl list-disc">
        <li>
          Wenn der Zuckergehalt den Höchstwert von halbtrocken überschreitet, aber nicht mehr als 45 g je Liter beträgt
        </li>
      </ul>
      <p class="text-base text-2xl font-bold">
        Süß; doux, dolce, sweet:
      </p>
      <ul class="ml-6 my-5 text-base text-2xl list-disc">
        <li>
          Wenn der Zuckergehalt mindestens 45 g je Liter beträgt
        </li>
      </ul>
      <p class="text-base text-2xl font-bold">
        Mild:
      </p>
      <ul class="ml-6 my-5 text-base text-2xl list-disc">
        <li>
          Weine mit einem Restzuckergehalt über 45 g je Liter. Der Begriff wird für Weine verwendet, bei denen die Säure
          in den Hintergrund tritt.
        </li>
      </ul>
      <p class="text-base text-2xl font-bold">
        Feinherb:
      </p>
      <ul class="ml-6 my-5 text-base text-2xl list-disc">
        <li>
          Dieser Begriff ist weinrechtlich nicht definiert. Er bezeichnet Weine, die nicht trocken, aber auch nicht süß
          sind. Meist Weine im Bereich halbtrocken.
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'

export default {
  components: { PageHeader },
}
</script>
